export const regimenFiscal = [
  {
   "c_RegimenFiscal": 601,
   "descripcion": "General de Ley Personas Morales",
   "Física": "No",
   "Moral": "Sí",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 603,
   "descripcion": "Personas Morales con Fines no Lucrativos",
   "Física": "No",
   "Moral": "Sí",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 605,
   "descripcion": "Sueldos y Salarios e Ingresos Asimilados a Salarios",
   "Física": "Sí",
   "Moral": "No",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 606,
   "descripcion": "Arrendamiento",
   "Física": "Sí",
   "Moral": "No",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 607,
   "descripcion": "Régimen de Enajenación o Adquisición de Bienes",
   "Física": "Sí",
   "Moral": "No",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 608,
   "descripcion": "Demás ingresos",
   "Física": "Sí",
   "Moral": "No",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 610,
   "descripcion": "Residentes en el Extranjero sin Establecimiento Permanente en México",
   "Física": "Sí",
   "Moral": "Sí",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 611,
   "descripcion": "Ingresos por Dividendos (socios y accionistas)",
   "Física": "Sí",
   "Moral": "No",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 612,
   "descripcion": "Personas Físicas con Actividades Empresariales y Profesionales",
   "Física": "Sí",
   "Moral": "No",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 614,
   "descripcion": "Ingresos por intereses",
   "Física": "Sí",
   "Moral": "No",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 615,
   "descripcion": "Régimen de los ingresos por obtención de premios",
   "Física": "Sí",
   "Moral": "No",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 616,
   "descripcion": "Sin obligaciones fiscales",
   "Física": "Sí",
   "Moral": "No",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 620,
   "descripcion": "Sociedades Cooperativas de Producción que optan por diferir sus ingresos",
   "Física": "No",
   "Moral": "Sí",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 621,
   "descripcion": "Incorporación Fiscal",
   "Física": "Sí",
   "Moral": "No",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 622,
   "descripcion": "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras",
   "Física": "No",
   "Moral": "Sí",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 623,
   "descripcion": "Opcional para Grupos de Sociedades",
   "Física": "No",
   "Moral": "Sí",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 624,
   "descripcion": "Coordinados",
   "Física": "No",
   "Moral": "Sí",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 625,
   "descripcion": "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
   "Física": "Sí",
   "Moral": "No",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  },
  {
   "c_RegimenFiscal": 626,
   "descripcion": "Régimen Simplificado de Confianza",
   "Física": "Sí",
   "Moral": "Sí",
   "Fecha de inicio de vigencia": "01\/01\/2022"
  }
 ];
export const usoCfdi = [
  ["G01", "Adquisición de mercancias", true, true],
  ["G02", "Devoluciones, descuentos o bonificaciones", true, true],
  ["G03", "Gastos en general", true, true],
  ["I01", "Construcciones", true, true],
  ["I02", "Mobilario y equipo de oficina por inversiones", true, true],
  ["I03", "Equipo de transporte", true, true],
  ["I04", "Equipo de computo y accesorios", true, true],
  ["I05", "Dados, troqueles, moldes, matrices y herramental", true, true],
  ["I06", "Comunicaciones telefónicas", true, true],
  ["I07", "Comunicaciones satelitales", true, true],
  ["I08", "Otra maquinaria y equipo", true, true],
  [
    "D01",
    "Honorarios médicos, dentales y gastos hospitalarios.",
    true,
    false
  ],
  ["D02", "Gastos médicos por incapacidad o discapacidad", true, false],
  ["D03", "Gastos funerales.", true, false],
  ["D04", "Donativos.", true, false],
  [
    "D05",
    "Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación).",
    true,
    false
  ],
  ["D06", "Aportaciones voluntarias al SAR.", true, false],
  ["D07", "Primas por seguros de gastos médicos.", true, false],
  ["D08", "Gastos de transportación escolar obligatoria.", true, false],
  [
    "D09",
    "Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.",
    true,
    false
  ],
  ["D10", "Pagos por servicios educativos (colegiaturas)", true, false],
  ["P01", "Por definir", true, true]
];
